import formatTableJson from '@/config/tableComponentParams.js'
import { enbaleDisableStatus } from '@/config/status'
import i18n from '@/locales'
export default formatTableJson([
  {
    filed: 'version',
    label: i18n.t('Fota.firmwareVersion')
  },
  {
    filed: 'versionAlias',
    label: i18n.t('Fota.versionAlias')
  },
  {
    filed: 'fileLength',
    label: i18n.t('Fota.firmwareSize'),
    formatFn: function(_, row) {
      return row.fileLength ? Math.floor(row.fileLength / 1024) + 'KB' : '-'
    }
  },
  {
    filed: 'fileMd5',
    label: i18n.t('Fota.MD5'),
    width: 250,
    showOverflowTooltip: true
  },
  {
    filed: 'createTime',
    label: i18n.t('Fota.createTime'),
    type: 'time',
    width: 170
  },
  {
    filed: 'creatorName',
    label: i18n.t('Fota.creator')
  },
  {
    filed: 'status',
    label: i18n.t('Fota.status'),
    type: 'status',
    statusProps: enbaleDisableStatus,
    formatFn: function(_, row) {
      switch (row.status) {
        case 'ENABLE':
          return i18n.t('Common.enable')
        case 'DISABLED':
          return i18n.t('Common.disabled')
        default:
          return '-'
      }
    }
  }
])
